import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AbstractService } from '../../../../core/common/service/AbstractService';

 /**
 * Login Service  
 * ログイン画面のサービスになります。
 * 
 * @author GAUSS
 * @since 2018/06/21
 */
@Injectable()
export class LoginIndexService extends AbstractService {
  
  /** コンストラクタ */
  public constructor(private  httpClient:  HttpClient) {
    super();
  }
}